// removed by extract-text-webpack-plugin
module.exports = {"root":"root___1zeXc"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/Merchant/Order/SearchForm.less
// module id = tdA4
// module chunks = 28